const CallOut = (props) => {
  const { title, description, buttonCTA, textColor = "tw-text-black", backgroundColor = "tw-bg-white" } = props;

  return (
    <section className={`lg:tw-p-25 tw-p-14 ${backgroundColor}`}>
      <div className="tw-container tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 lg:tw-gap-28 tw-gap-10 tw-items-center">
        <div className="lg:tw-col-span-2">
          {title && (
            <h2 className={`tw-font-helv tw-text-4xl tw-normal-case tw-font-bold tw-mb-4 ${textColor}`}>{title}</h2>
          )}
          {description && (
            <div
              className={`tw-prose [&>*]:tw-font-helv ${textColor}`}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </div>
        {buttonCTA?.text && (
          <a
            href={buttonCTA.url}
            target={buttonCTA.target}
            className="tw-font-helv tw-bg-primary-red tw-py-2 tw-px-6 tw-w-fit tw-mb-4"
          >
            <span className="lg:tw-text-xl tw-text-white">{buttonCTA.text}</span>
          </a>
        )}
      </div>
    </section>
  );
};

export default CallOut;
